/* eslint-disable react-hooks/exhaustive-deps */

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import { GridSearchIcon } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import { Button, CardContent, InputAdornment, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import { useDispatch } from "react-redux";
import { appConstants } from "utils/appConstants";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { deleteRoleRecords, fetchRoles } from "utils/superAdminApi";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconMenu from "components/CustomMaterialMenu/Custom";
import { getScreenRight } from "utils/generic";
let searchParameter = "";
let LOGIN_DETAILS;
const SCREEN_NAME = "Roles";
let SCREEN_RIGHT;
function BURoles(searchTerm) {

  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [rows, setRows] = useState([]);
  const [disableColor, setDisableColor] = useState(false);
  const [screenAccess, setScreenAccess] = useState(false);
  const [values, setValues] = useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    roleName: "",
    roleDescription: "",
    initialValue: "",
    finalValue: "",
    applicableForBusinessUser: "",
    searchParameterList: ['planName', 'defaultPlanRole', 'applicableForBusinessUser', 'roleDescription', 'roleName'],
    roles: [], // add roles array to store data fetched from API
  });


  if (sessionStorage.getItem('LOGIN_DETAILS') !== undefined && sessionStorage.getItem('LOGIN_DETAILS') != null) {
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.userID = LOGIN_DETAILS._id;
  }

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchRolesData();
    })();
  }, [values.sortingType, perPage, dispatch]);

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };


  const handleDeleteDialogeClick = async (_id) => {
    if (LOGIN_DETAILS._id === _id) {
      showResMsg(genericMessage.logusercantdeleted, 2000, false);
      return
    }
    values._id = []
    values._id.push(_id)
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };


  function handleDelete(roleId) {
    if (rows.some((role) => role._id === values._id[0] && role.defaultPlanRole === "Yes")) {
      console.log("adsada",)
      showResMsg(genericMessage.planDefaultRolecantdeleted, 2000, false);

    } else {
      deleteRole(roleId);
      setDeleteDialogeFlag(!deleteDialogeFlag);
    }
  }

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchRolesData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };


  const deleteRole = async (roleId) => {
    await deleteRoleRecords(values, (data) => {
      fetchRolesData();
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  const fetchRolesData = async () => {
    values.searchParameter = searchParameter;
    await fetchRoles(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  };

  async function getRight() {
    setDisableColor(false)
    let right = await getScreenRight("User Roles")
    console.log("SCREEN_RIGHT", right)
    if (right === "Full Access") {
      setDisableColor(false)
      setScreenAccess(true)
    } else {
      setDisableColor(true)
    }
  }



  let columns = [

    {
      // name: "Role Name",
      name: <p style={{ fontSize: "12px" }}>Role Name</p>,
      // selector: row => row.roleName,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.roleName}</span>
      ),
      sortable: true,
      sortField: 'roleName',
      left: true,
    },
    {
      // name: "Role Description",
      name: <p style={{ paddingLeft: "14px", fontSize: "12px" }}>Role Description</p>,
      // selector: row => row.roleDescription,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row.roleDescription}</span>
      ),
      sortable: true,
      sortField: 'roleDescription',
      center: true,
    },
    // {
    //   // name: "Plan Name",
    //   name: <p style={{ paddingLeft: "20px", fontSize: "12px" }}>Plan Name</p>,
    //   // selector: row => row.planName,
    //   selector: row => (
    //     <span style={{ fontSize: "12px" }}>{row.planName}</span>
    //   ),
    //   sortable: true,
    //   sortField: 'planName',
    //   center: true,
    // },

    {
      // name: "Action(s)",
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      // selector: row => row._id,
      selector: row => (
        <span style={{ fontSize: "12px" }}>{row._id}</span>
      ),
      center: true,
      cell: row => <IconMenu size="small" row={
        <>
          {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
          <Grid style={{ width: "100%" }} item>
            <Link
              to={`/myroles/edit/${row._id}`} disabled={!screenAccess}
            >
              <p style={darkMode ? { color: "white" } : { color: "black" }}>
                <TimelineItem color="success"
                  // icon="edit"
                  icon={<EditIcon className="actionicon" />}
                  title="Edit" />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit</p>
            </Link>
          </Grid>

          <Grid style={{ width: "100%" }} item >
            <p onClick={() => handleDeleteDialogeClick(row._id)} style={darkMode ? { color: "white" } : { color: "black" }} disabled={!screenAccess}>
              <TimelineItem
                color="error"
                // icon="delete"
                icon={<DeleteIcon className="actionicon" />}
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete</p>
          </Grid>

          {/* </Grid> */}
        </>
      } />,
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />


      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="User Roles" />
          <Grid container display={"flex"} justifyContent="end" mt={2} gap={2} >

            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchRolesData();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchRolesData}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              {/* <Link to={"/myroles/new"}>
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"} style={{ height: "38.11px", width: "99px" }} >
                  Add New
                </MDButton>
              </Link> */}
              {screenAccess ?
                <Link to={"/myroles/new"}>
                  <MDButton
                    variant="contained"
                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                    color={disableColor ? "secondary" : "success"} style={{ height: "38.11px", width: "99px" }}
                  >
                    Add New
                  </MDButton>
                </Link>
                :
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color="secondary"
                  style={{ height: "38.11px" }}
                >
                  Add New
                </MDButton>
              }
            </div>
          </Grid>
          {/* <CardContent> */}
          <BTable
            title={title}
            columns={columns}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}

          />
          {/* </CardContent> */}
        </Card>
      </div >

      < DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}

      />
    </DashboardLayout>
  );

}

export default BURoles;
